<template>
  <div :class="$style.assetsContent">

    <div>
      <assets-job-sidebar :show-sidebar="showJobSidebar"
                          :sidebar-type="sidebarType"
                          :edited-item="editedItem"
                          :edited-item-id="editedItemId"
                          :employment-person="employmentPerson"
                          @hideSidebar="hideJobSidebar"/>

      <assets-real-estate-sidebar :show-sidebar="showRealEstateSidebar"
                                  :sidebar-type="sidebarType"
                                  :edited-item="editedItem"
                                  :edited-item-id="editedItemId"
                                  @hideSidebar="hideRealEstateSidebar"/>

      <assets-real-estate-details :show-sidebar="showRealEstateDetails"
                                  :detailed-item="detailedItem"
                                  @hideSidebar="hideRealEstateDetails"
                                  @editItem="editRealEstate"/>

      <assets-vehicle-sidebar :show-sidebar="showVehicleSidebar"
                              :sidebar-type="sidebarType"
                              :edited-item="editedItem"
                              :edited-item-id="editedItemId"
                              @hideSidebar="hideVehicleSidebar"/>

      <assets-vehicle-details :show-sidebar="showVehicleDetails"
                              :detailed-item="detailedItem"
                              @hideSidebar="hideVehicleDetails"
                              @editItem="editVehicle"/>

      <assets-other-asset-sidebar :show-sidebar="showAssetSidebar"
                                  :sidebar-type="sidebarType"
                                  :edited-item="editedItem"
                                  :edited-item-id="editedItemId"
                                  @hideSidebar="hideAssetSidebar"/>

      <assets-other-assets-details :show-sidebar="showAssetDetails"
                                   :detailed-item="detailedItem"
                                   @hideSidebar="hideAssetDetails"
                                   @editItem="editAsset"/>

    </div>

      <app-stepper :class="$style.assetsStepper"
                   :formSteps="formSteps"
                   :current-step="currentStep"
                   :is-current-form-valid = "isCurrentFormValid"
                   :reset-btn="getResetButton"
                   @prevStep="prevStep"
                   @nextStep = "nextStep"
                   @nextStepDone = "nextStepDone"
                   @resetForm="resetForm"
                   previous="personal">

      <template v-slot:stepperContent>

        <v-stepper-content step="1">
          <vue-custom-scrollbar class="scroll-area"
                                :settings="settings">
          <assets-overview :completed-step="completedStep"/>
          </vue-custom-scrollbar>
        </v-stepper-content>

        <v-stepper-content step="2">
          <vue-custom-scrollbar class="scroll-area"
                                :settings="settings">
            <assets-employment :current-step="currentStep"
                               :completed-step="completedStep"
                               :previous-step="previousStep"
                               :reset="currentFormReset"
                               @nextStepDone = "nextStepDone"
                               @changeValid="setCurrentFormValid"
                               @restoreReset="restoreReset"
                               @displayJobSidebar="displayJobSidebar"
                               @hideJobSidebar="hideJobSidebar"
                               @editJob="editJob"
                               @onError="handleError"/>
          </vue-custom-scrollbar>
        </v-stepper-content>

        <v-stepper-content step="3">
          <vue-custom-scrollbar class="scroll-area"
                                :settings="settings">
            <assets-real-estate :current-step="currentStep"
                                :completed-step="completedStep"
                                :previous-step="previousStep"
                                :reset="currentFormReset"
                                @nextStepDone = "nextStepDone"
                                @changeValid="setCurrentFormValid"
                                @restoreReset="restoreReset"
                                @displayRealEstateSidebar="displayRealEstateSidebar"
                                @hideRealEstateSidebar="hideRealEstateSidebar"
                                @editRealEstate="editRealEstate"
                                @onError="handleError"
                                @showDetails="displayRealEstateDetails"/>
          </vue-custom-scrollbar>
        </v-stepper-content>

        <v-stepper-content step="4">
          <vue-custom-scrollbar class="scroll-area"
                                :settings="settings">
            <assets-vehicle-information  :current-step="currentStep"
                                         :completed-step="completedStep"
                                         :previous-step="previousStep"
                                         :reset="currentFormReset"
                                         @nextStepDone = "nextStepDone"
                                         @changeValid="setCurrentFormValid"
                                         @restoreReset="restoreReset"
                                         @displayVehicleSidebar="displayVehicleSidebar"
                                         @hideVehicleSidebar="hideVehicleSidebar"
                                         @editVehicle="editVehicle"
                                         @onError="handleError"
                                         @showDetails="displayVehicleDetails"/>
          </vue-custom-scrollbar>
        </v-stepper-content>

        <v-stepper-content step="5">
          <vue-custom-scrollbar class="scroll-area"
                                :settings="settings">
            <assets-other-assets :current-step="currentStep"
                                 :completed-step="completedStep"
                                 :previous-step="previousStep"
                                 :reset="currentFormReset"
                                 @nextStepDone = "nextStepDone"
                                 @changeValid="setCurrentFormValid"
                                 @restoreReset="restoreReset"
                                 @displayAssetSidebar="displayAssetSidebar"
                                 @hideAssetSidebar="hideAssetSidebar"
                                 @editAsset="editAsset"
                                 @onError="handleError"
                                 @showDetails="displayAssetDetails"/>
          </vue-custom-scrollbar>
        </v-stepper-content>

        <v-stepper-content step="6">
          <vue-custom-scrollbar class="scroll-area"
                                :settings="settings">
            <assets-household-income :current-step="currentStep"
                                     :completed-step="completedStep"
                                     :previous-step="previousStep"
                                     :reset="currentFormReset"
                                     @changeValid="setCurrentFormValid"
                                     @onError="handleError"
                                     @restoreReset="restoreReset"/>
          </vue-custom-scrollbar>
        </v-stepper-content>

      </template>
    </app-stepper>
  </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar';
import AssetsOverview from '@/app/assets/components/assets-overview';
import AssetsEmployment from '@/app/assets/components/assets-employment';
import AssetsJobSidebar from '@/app/assets/components/assets-job-sidebar';
import AssetsRealEstate from '@/app/assets/components/assets-real-estate';
import AssetsRealEstateSidebar from '@/app/assets/components/assets-real-estate-sidebar';
import AssetsRealEstateDetails from '@/app/assets/components/assets-real-estate-details';
import AssetsVehicleInformation from '@/app/assets/components/assets-vehicle-information';
import AssetsVehicleSidebar from '@/app/assets/components/assets-vehicle-sidebar';
import AssetsVehicleDetails from '@/app/assets/components/assets-vehicle-details';
import AssetsOtherAssets from '@/app/assets/components/assets-other-assets';
import AssetsOtherAssetSidebar from '@/app/assets/components/assets-other-asset-sidebar';
import AssetsOtherAssetsDetails from '@/app/assets/components/assets-other-assets-details';
import AssetsHouseholdIncome from '@/app/assets/components/assets-household-income';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    VueCustomScrollbar,
    AssetsJobSidebar,
    AssetsOverview,
    AssetsEmployment,
    AssetsRealEstate,
    AssetsRealEstateSidebar,
    AssetsRealEstateDetails,
    AssetsVehicleInformation,
    AssetsVehicleSidebar,
    AssetsVehicleDetails,
    AssetsOtherAssets,
    AssetsOtherAssetSidebar,
    AssetsOtherAssetsDetails,
    AssetsHouseholdIncome,
  },
  data() {
    return {
      formSteps: [
        {
          number: 1,
          title: 'Overview',
        },
        {
          number: 2,
          title: 'Employment',
        },
        {
          number: 3,
          title: 'Real Estate',
        },
        {
          number: 4,
          title: 'Vehicles',
        },
        {
          number: 5,
          title: 'Other Assets',
        },
        {
          number: 6,
          title: 'Household',
        },
      ],
      currentStep: 1,
      completedStep: 0,
      previousStep: 0,
      isCurrentFormValid: false,
      currentFormReset: false,
      showJobSidebar: false,
      employmentPerson: '',
      showRealEstateSidebar: false,
      showRealEstateDetails: false,
      showVehicleSidebar: false,
      showVehicleDetails: false,
      showAssetSidebar: false,
      showAssetDetails: false,
      editedItem: null,
      editedItemId: 0,
      detailedItem: null,
      sidebarType: 'add',
      settings: {
        wheelSpeed: 0.5,
      },
    };
  },
  methods: {
    ...mapActions([
      'getFormProgress',
    ]),
    /* Previous step */
    prevStep(step) {
      if (this.currentStep > 1) {
        this.previousStep = step;
        this.currentStep = step - 1;
        this.completedStep = step - 2;
      }
    },
    /* Set completedStep to the step value
    that is the number of the step where the event came from */
    nextStep(step) {
      this.previousStep = step;
      this.completedStep = step;
    },
    /* Make next step */
    nextStepDone(step) {
      this.currentStep = step + 1;
      this.getFormProgress(this.getUserId);
    },
    setCurrentFormValid(isValid) {
      this.isCurrentFormValid = isValid;
    },
    /* Set resetForm property to True that means that
    Reset button was clicked at one of the forms */
    resetForm() {
      this.currentFormReset = true;
    },
    /* Restore resetForm property back to False after some form was reset */
    restoreReset() {
      this.currentFormReset = false;
    },
    /* Job sidebars methods */
    displayJobSidebar(person) {
      this.showJobSidebar = true;
      this.employmentPerson = person;
    },
    hideJobSidebar() {
      this.showJobSidebar = false;
      this.employmentPerson = '';
      this.sidebarType = 'add';
    },
    /* Set job item for editing */
    editJob(item, id, person) {
      this.editedItem = item;
      this.editedItemId = id;
      this.employmentPerson = person;
      this.displayJobSidebar(person);
      this.sidebarType = 'edit';
    },
    /* Real Estate sidebars methods */
    displayRealEstateSidebar() {
      this.showRealEstateSidebar = true;
    },
    hideRealEstateSidebar() {
      this.showRealEstateSidebar = false;
      this.sidebarType = 'add';
    },
    /* Set real estate item for editing */
    editRealEstate(item, id) {
      this.editedItem = item;
      this.editedItemId = id;
      this.displayRealEstateSidebar();
      this.sidebarType = 'edit';
    },
    displayRealEstateDetails(item) {
      this.detailedItem = item;
      this.showRealEstateDetails = true;
    },
    hideRealEstateDetails() {
      this.showRealEstateDetails = false;
    },
    /* Vehicle sidebars methods */
    displayVehicleSidebar() {
      this.showVehicleSidebar = true;
    },
    hideVehicleSidebar() {
      this.showVehicleSidebar = false;
      this.sidebarType = 'add';
    },
    /* Set vehicle item for editing */
    editVehicle(item, id) {
      this.editedItem = item;
      this.editedItemId = id;
      this.displayVehicleSidebar();
      this.sidebarType = 'edit';
    },
    displayVehicleDetails(item) {
      this.detailedItem = item;
      this.showVehicleDetails = true;
    },
    hideVehicleDetails() {
      this.showVehicleDetails = false;
    },
    /* Other Assets sidebars methods */
    displayAssetSidebar() {
      this.showAssetSidebar = true;
    },
    hideAssetSidebar() {
      this.showAssetSidebar = false;
      this.sidebarType = 'add';
    },
    /* Set asset item for editing */
    editAsset(item, id) {
      this.editedItem = item;
      this.editedItemId = id;
      this.displayAssetSidebar();
      this.sidebarType = 'edit';
    },
    displayAssetDetails(item) {
      this.detailedItem = item;
      this.showAssetDetails = true;
    },
    hideAssetDetails() {
      this.showAssetDetails = false;
    },
    /* Sets back steps value if an error occurred */
    handleError() {
      this.previousStep = this.currentStep - 1;
      this.completedStep = this.currentStep - 1;
    },
  },
  computed: {
    ...mapGetters([
      'getUserId',
    ]),
    getResetButton() {
      return this.currentStep === 6;
    },
  },
};
</script>

<style lang="scss" module>
  @import "@/styles/variables.scss";

  .assetsContent {
    width: 100%;
    display: flex;

    .assetsStepper {
      width: 100%;
    }
  }
</style>
